module.exports = __webpack_public_path__ + "static/media/circle_filled_grey.ee9a45df.svg";